import { render, staticRenderFns } from "./merchant-management.vue?vue&type=template&id=cddac722&scoped=true"
import script from "./merchant-management.vue?vue&type=script&lang=js"
export * from "./merchant-management.vue?vue&type=script&lang=js"
import style0 from "./merchant-management.vue?vue&type=style&index=0&id=cddac722&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cddac722",
  null
  
)

export default component.exports